import { flexPos } from '@/assets/styles/mixin';
import { FC, ReactNode } from 'react';
import { styled } from 'styled-components';
import BubbleStatus, { BubbleReadStatus } from './BubbleStatus';
import { EMessageStatus } from '@/store/messageStore';
import { $fontSize, $paddingX, $paddingY, phoneSize } from '@/assets/styles/mediaSize';
import { callFromExternal } from '@/utils';
import { getValue } from '@/externalConfig/conf'

interface ITextBubbleProps {
  msgBody: string;
  status: EMessageStatus;
  isMe?: boolean;
  isRead: boolean;
  onBubbleClick?: (status: EMessageStatus) => void;
}
const external = callFromExternal()
export const TextBubbleWrap = styled.div<{ $isMe?: boolean }>`
  ${(props) => (props.$isMe ? flexPos('flex-end') : flexPos('flex-start'))}

  .bubble-content {
    background: ${(props) => (props.$isMe ? external ? getValue('bubbleBgColor') : '#0054fc1a' : external ? 'rgba(246, 246, 246, 0.06)' : '#fff')};
    ${$paddingX('24rem', '12rem')}
    ${$paddingY('24rem', '12rem')}
    ${$fontSize('28rem', '14rem')}

    border-radius: ${(props) => (external ? '8px' : props.$isMe ? ' 24rem 0 24rem 24rem;' : '0 24rem 24rem 24rem')};
    @media (min-width: ${phoneSize}) {
      border-radius: ${(props) => (external ? '8px' : props.$isMe ? ' 12rem 0 12rem 12rem;' : '0 12rem 12rem 12rem')};
    }

    max-width: 500rem;
    word-break: break-all;
    overflow-x: auto;
  }
`;

const TextBubble: FC<ITextBubbleProps> = ({ msgBody, isMe, onBubbleClick, status, isRead }) => {
  const msgContent = useMemo(() => {
    return msgBody?.replace?.(/\n/gi, '<br>');
  }, [msgBody]);

  return (
    <TextBubbleWrap $isMe={isMe}>
      <BubbleReadStatus isRead={!!isMe && isRead} />

      <BubbleStatus
        onClick={(status) => onBubbleClick?.(status)}
        className={isMe ? 'order-1' : 'order-2'}
        status={status}
      />

      <div
        className={`bubble-content ${external ? 'external-bubble-content' : isMe ? 'order-2 ml-16' : 'order-1 mr-16'}`}
        dangerouslySetInnerHTML={{ __html: msgContent }}
      ></div>

      {/* <div>{msgBody}</div> */}
    </TextBubbleWrap>
  );
};

export default TextBubble;
